import React, { createContext, useContext, useState } from "react";

import { IEncryptedData, decryptPayload, encryptPayload } from "utils";
import { ZERO } from "utils/constants";

import {
  IAppContextProps,
  IAppProviderProps,
  ITransactionRefIdMap,
} from "./types";

export const DEFAULT_TRANSACTION_REF_ID_MAP: ITransactionRefIdMap = {
  reference: "",
  id: "",
};

const AppContext = createContext<IAppContextProps>({
  handleSaveTransactionRefId: () => {
    // default
  },
  handleGetTransactionRefId: async (_: string) => {
    return "";
  },
  tableHeaderCTAWidth: ZERO,
  handleUpdateTableHeaderCTAWidth: () => {
    return null;
  },
});

export const AppProvider = (props: IAppProviderProps) => {
  const { children } = props;
  const TRANSACTION_REF_ID_MAP = "TRANSACTION_REF_ID_MAP";
  const [tableHeaderCTAWidth, setTableHeaderCTAWidth] = useState<number>(ZERO);

  const handleUpdateTableHeaderCTAWidth = (value: number) => {
    setTableHeaderCTAWidth(value);
  };

  const handleSaveTransactionRefId = ({
    reference,
    id,
  }: ITransactionRefIdMap) => {
    const encryptedData = encryptPayload({
      [reference]: id,
    });
    localStorage.setItem(TRANSACTION_REF_ID_MAP, JSON.stringify(encryptedData));
  };

  const handleGetTransactionRefId = async (
    reference: string
  ): Promise<string> => {
    let id = "";
    const encryptedPayload = localStorage.getItem(TRANSACTION_REF_ID_MAP);

    if (encryptedPayload) {
      const payload = JSON.parse(encryptedPayload) as IEncryptedData;
      const refId: Record<string, string> = await decryptPayload(payload);
      id = refId?.[reference];
    }
    return id;
  };

  return (
    <AppContext.Provider
      value={{
        handleSaveTransactionRefId,
        handleGetTransactionRefId,
        tableHeaderCTAWidth,
        handleUpdateTableHeaderCTAWidth,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
